import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbDatepickerNavigateEvent,
  NgbDateStruct,
  NgbDatepicker,
  NgbInputDatepicker,
} from '@ng-bootstrap/ng-bootstrap';
import dayjs from 'dayjs';
import { Model } from 'src/app/shared/models/clux/model-legacy';
import { SharedService } from '../../services/shared.service';
import { CustomDatepickerI18n } from '../../utils/custom-datepicker-i18n';
import { NgbDateCustomParserFormatter } from '../../utils/dateformater';
import { NgClass, LowerCasePipe } from '@angular/common';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { CheckboxTemplateComponent } from '../checkbox-template/checkbox-template.component';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatButton } from '@angular/material/button';
import { DATEPICKER_CONTAINER, DatepickerContainer } from '../../utils/datepicker.util';

@Component({
  selector: 'app-filter-popup',
  templateUrl: './filter-popup.component.html',
  styleUrls: ['./filter-popup.component.scss'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, NgbDatepicker, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, NgbInputDatepicker, CheckboxTemplateComponent, MatRadioGroup, MatRadioButton, MatButton, LowerCasePipe],
})
export class FilterPopupComponent implements OnInit, OnChanges {
  public elm = inject(ElementRef);
  public rendrer = inject(Renderer2);
  public calendar = inject(NgbCalendar);
  private sharedService = inject(SharedService);
  private fb = inject(UntypedFormBuilder);

  @Input() public options: Model.CategoryOptions[];
  @Input() public title: string;
  @Input() public item: Model.Category;
  @Input() public rightJustify: boolean;
  @Input() public maxEndDate: NgbDate;
  @Input() public checklist: boolean;
  @Input() public datesToEnable: string[];
  @Input() public isDateSelected: boolean;
  @Input() public useDatepickerDateRange: boolean = false;
  /**
   * Set to `true` when this filter is rendered inside a modal (Angular Material
   * `MatDialog`), e.g. the reports "Get new report" dialog. Controls where the
   * ngb-datepicker calendar popups are attached:
   *   - `false` (default, on a normal page): popups attach to `<body>` so they can
   *     escape clipping/overflow parents.
   *   - `true` (inside a dialog): popups render inline instead. A CDK v22 dialog
   *     renders in the browser's top layer, which sits above all normal-DOM content
   *     regardless of z-index — so a `<body>`-attached popup would render BEHIND the
   *     dialog and be invisible. Rendering inline keeps it inside the dialog's layer.
   * See datepicker.util.ts for the full explanation.
   */
  @Input() public isRenderedInModal = false;

  public get datepickerContainer(): DatepickerContainer {
    return this.isRenderedInModal ? DATEPICKER_CONTAINER.modal : DATEPICKER_CONTAINER.page;
  }
  @Output() public popupCancel = new EventEmitter();
  @Output() public categoryFilterChanged = new EventEmitter<Model.FilterOption<Model.CategoryOptions[]>>();
  @Output() public dateFilterChanged = new EventEmitter<Model.FilterOption<Model.DateOptions>>();
  @Output() public filterCleared = new EventEmitter<Model.EmitSelected>();
  @Output() public selectedMonths = new EventEmitter<NgbDatepickerNavigateEvent>();
  public foptions: Model.CategoryOptions[];
  public radioOptions: Model.CategoryOptions[];
  public ftitle: string;
  public dirtyFlag: boolean;
  public selectedFilterOptions: Model.FilterOption<Model.CategoryOptions[]>;
  public hoveredDate: NgbDate;
  public fromDate: NgbDateStruct;
  public toDate: NgbDateStruct;
  public filterFlag: boolean;
  public isEnableClear: boolean;
  public datePickerSettings: Model.DateSettings;
  public selectedDate: NgbDateStruct;
  public selectedEndDate: NgbDateStruct;
  public minimumDate: NgbDate;
  public maximumDate: NgbDate;
  public isOptionsEmpty: boolean;
  public outsideDays: 'visible' | 'collapsed' | 'hidden';
  public isAllSelectedOptions: boolean;
  public dateRangeForm: UntypedFormGroup;
  public errorMessage: string;
  public isStartValid: boolean;
  public isEndValid: boolean;
  public enterDateManually: boolean;
  public itemName: string;
  public isRadio: boolean;
  public selectedRadio: boolean[] = [];
  public selectedOptions: Model.CategoryOptions[] = [];
  public markDisabled: (date: NgbDate) => boolean;
  public startDate: Model.NextDate;
  public isLoading: boolean;

  constructor() {
    const calendar = this.calendar;

    const fromDate: string = sessionStorage.getItem('fromDate');
    const toDate: string = sessionStorage.getItem('toDate');
    const selectedDate: string = sessionStorage.getItem('fromDate');
    const selectedEndDate: string = sessionStorage.getItem('toDate');
    this.dirtyFlag = true;
    this.isEnableClear = true;
    this.fromDate = fromDate ? this.getNgbDate(fromDate) : null; // calendar.getToday()
    this.selectedDate = selectedDate ? this.getNgbDate(selectedDate) : null;
    this.selectedEndDate = selectedEndDate ? this.getNgbDate(selectedEndDate) : null; // calendar.getToday()
    this.toDate = toDate ? this.getNgbDate(toDate) : null;
    this.minimumDate = calendar.getToday();
    this.enterDateManually = false;
    this.startDate = { year: dayjs().year(), month: dayjs().month() };
    this.isLoading = true;
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: HTMLElement): void {
    if (targetElement) {
      if (
        targetElement.tagName === 'HTML' ||
        (!targetElement.classList.contains('active-filter-link') &&
          !targetElement.classList.contains('btn-light') &&
          !targetElement.classList.contains('no-border-btn') &&
          !targetElement.offsetParent.classList.contains('filter-container') &&
          !targetElement.classList.contains('mat-mdc-button-wrapper') &&
          !targetElement.offsetParent.classList.contains('filter-category') &&
          !targetElement.offsetParent.classList.contains('mat-mdc-form-field-infix') &&
          !targetElement.classList.contains('mat-mdc-form-field-infix') &&
          !targetElement.classList.contains('mat-mdc-form-field-flex') &&
          !targetElement.offsetParent.classList.contains('mat-mdc-form-field-wrapper') &&
          !targetElement.offsetParent.classList.contains('mat-mdc-text-field-wrapper') &&
          !targetElement.offsetParent.classList.contains('dropdown-menu') &&
          !targetElement.offsetParent.classList.contains('mdc-radio') &&
          !targetElement.classList.contains('ngb-dp-month-name') &&
          !targetElement.classList.contains('ngb-dp-arrow-btn') &&
          !targetElement.classList.contains('mat-mdc-button-touch-target') &&
          !targetElement.classList.contains('mdc-checkbox__native-control') &&
          !targetElement.classList.contains('mdc-button__label') &&
          !targetElement.classList.contains('date-icon') &&
          !targetElement.classList.contains('icon-date-range') &&
          !targetElement.offsetParent?.classList.contains('date-icon'))
      ) {
        this.closePopup();
      }
    }
  }
  public ngOnInit(): void {
    this.datePickerSettings = {
      navigation: 'arrows',
      showWeekNumbers: false,
    };
    this.maximumDate = this.maxEndDate;
    this.isOptionsEmpty = this.itemName === 'Date Range' || this.itemName === 'Date' ? !this.options?.length : false;
    const selectedEndDate: string = sessionStorage.getItem('toDate');
    this.selectedEndDate = selectedEndDate ? this.getNgbDate(selectedEndDate) : this.calendar.getToday();
    this.outsideDays = 'collapsed';
    this.dateRangeForm = this.fb.group({
      selectedDate: [this.selectedDate, this.validateStartDate.bind(this)],
      selectedEndDate: [this.selectedEndDate, this.validateEndDate.bind(this)],
    });
    this.errorMessage = '';

    setTimeout(() => {
      this.sharedService.stateNotification.subscribe((currentState) => {
        this.isLoading = currentState;
      });
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.isAllSelectedOptions = this.item.selectAllOption ? this.item.selectAllOption : false;
    this.isRadio = this.item.isRadio ? this.item.isRadio : false;

    if (!this.isDateSelected) {
      this.isEnableClear = true;
    }

    this.ftitle = this.title;

    if (changes.options && changes.options.currentValue) {
      this.foptions = this.options;
      if (this.isRadio) {
        this.radioOptions = this.options;
        const currentSelection: Model.FilterOption<Model.CategoryOptions[]> = JSON.parse(sessionStorage.getItem('payment-source-selected-item'));
        if (currentSelection) {
          this.handleSelectedItem(currentSelection);
        }
        if (!sessionStorage.getItem('isFilterClearApplied')) {
          this.clearRadioSelection();
        }
      }
    }

    if (changes.item && changes.item.currentValue) {
      this.itemName = changes.item.currentValue.name;
      this.isEnableClear = !changes.item.currentValue.applyFlag;
    }
    if (this.itemName === 'Date') {
      const today = this.calendar.getToday();
      this.minimumDate.month = today.month > 6 ? today.month - 6 : 12 + today.month - 6;
      this.minimumDate.year = today.year - (today.month > 6 ? 1 : 2);
    } else {
      this.minimumDate.year = this.calendar.getToday().year - 3;
    }

    if (changes.datesToEnable && changes.datesToEnable.currentValue) {
      this.updateDisabledDates();
    }

    if (!sessionStorage.getItem('isFilterClearApplied')) {
      this.isEnableClear = true;
    }

    if (!sessionStorage.getItem('statusApplied')) {
      this.clearRadioSelection();
    }
  }

  public categoryDirtyChange(event: Model.FilterOption<Model.CategoryOptions[]>): void {
    if (this.isRadio) {
      this.handleSelectedItem(event);
    }
    event['name'] = this.title.toLowerCase();
    this.dirtyFlag = event.selectedOptions.length > 0 ? false : true;
    this.dirtyFlag = event.selectedOptions.length === 0 && !(event.status.indexOf(true) > -1);
    if (event.selectedOptions.length > 0) {
      this.dirtyFlag = false;
      this.isEnableClear = false;
    } else {
      this.dirtyFlag = true;
      this.isEnableClear = true;
      if (sessionStorage.getItem('statusApplied') === 'true') {
        this.dirtyFlag = false;
        this.isEnableClear = true;
      }
    }
    this.selectedFilterOptions = event;
  }

  public clearFilter(filterName: string, foptions?: Model.CategoryOptions[], item?: Model.Category): void {
    const clearFilter: Model.EmitSelected = {
      name: filterName.toLowerCase(),
      status: true,
    };

    if (this.options === null || filterName === 'Date Range' || filterName === 'Date') {
      sessionStorage.removeItem('fromDate');
      sessionStorage.removeItem('toDate');
      this.toDate = null;
      this.fromDate = null;
    }

    if (filterName === 'Payment source') {
      sessionStorage.removeItem('payment-source-selected-item');
    }

    this.sharedService.setClearFilter(clearFilter);
    this.dirtyFlag = true;
    clearFilter.status = false;
    this.isEnableClear = true;
    this.filterCleared.emit(clearFilter);
    if (item && item.applyFlag) {
      item.applyFlag = false;
    }
    if (this.isRadio) {
      this.clearRadioSelection();
    }
    this.popupCancel.emit({ index: -1, active: false });
  }

  public getMinDate(): NgbDateStruct {
    return this.minimumDate && this.selectedDate;
  }

  public apply(item?: Model.Category): void {
    if (this.selectedFilterOptions && !this.enterDateManually) {
      this.selectedFilterOptions.selectedOptions = item.data.filter((o) => o.checked);
      this.categoryFilterChanged.emit(this.selectedFilterOptions);
      const getKeyFormat: string = this.ftitle && this.ftitle.toLowerCase().replace(/\s/g, '') + '-values';
      if (this.selectedFilterOptions.status.length > 0) {
        sessionStorage.setItem(getKeyFormat, JSON.stringify(this.selectedFilterOptions.status));
      }
      if (this.selectedFilterOptions.name === 'payment source') {
        sessionStorage.setItem('payment-source-selected-item', JSON.stringify(this.selectedFilterOptions));
      }
      sessionStorage.setItem('statusApplied', 'true');
      this.popupCancel.emit({ index: -1, active: true });
      if (this.selectedFilterOptions.status.length > 0) {
        const isAppliedValue: boolean = this.selectedFilterOptions.status.find((val) => val === true);
        if (!isAppliedValue) {
          item.applyFlag = false;
          this.popupCancel.emit({ index: -1, active: false });
        }
      }
      if (Array.isArray(this.selectedFilterOptions.selectedOptions) && this.selectedFilterOptions.selectedOptions.length === 0) {
        sessionStorage.removeItem('statusApplied');
      }
    } else {
      let dateFilterOptions: Model.FilterOption<Model.DateOptions>;
      if ((this.title === 'Date Range' && !this.useDatepickerDateRange) || this.enterDateManually) {
        dateFilterOptions = {
          name: this.title && this.title.toLowerCase(),
          selectedOptions: {
            fromDate: this.getFormatDate(this.selectedDate),
            toDate: this.getFormatDate(this.selectedEndDate),
          },
        };
      } else if (this.title === 'Date') {
        dateFilterOptions = {
          name: this.title && this.title.toLowerCase(),
          selectedOptions: {
            fromDate: this.getFormatDate(this.selectedDate),
          },
        };
      } else {
        dateFilterOptions = {
          name: this.title && this.title.toLowerCase(),
          selectedOptions: {
            fromDate: this.getFormatDate(this.fromDate),
            toDate: this.getFormatDate(this.toDate),
          },
        };
      }
      this.dirtyFlag = true;
      this.dateFilterChanged.emit(dateFilterOptions);
      this.popupCancel.emit({ index: -1, active: true });
    }

    sessionStorage.setItem('isFilterClearApplied', 'false');
  }

  public onDateSelection(date: NgbDate, isDateRange: boolean = true): void {
    this.dirtyFlag = false;
    this.isEnableClear = false;
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate) && isDateRange) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  public isHovered(date: NgbDate): boolean {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  public isInside(date: NgbDate): boolean {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  public isRange(date: NgbDate): boolean {
    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
  }

  public onRangeDateSelection(date: NgbDate, type: boolean): void {
    if (type) {
      this.selectedDate = date;
    } else {
      this.selectedEndDate = date;
    }
    if (this.selectedDate && this.selectedEndDate) {
      if (Date.parse(this.getFormatDate(this.selectedDate)) <= Date.parse(this.getFormatDate(this.selectedEndDate))) {
        this.dirtyFlag = false;
      } else {
        this.dirtyFlag = true;
      }
      this.isEnableClear = false;
    }
  }

  public onChangeEvent(event: NgbDate, flag: boolean): void {
    if (event && (event.year || event.month || event.day)) {
      if (flag) {
        if (!this.selectedDate) {
          this.selectedDate = {
            year: null,
            month: null,
            day: null,
          };
        }
        this.selectedDate.year = event.year;
        this.selectedDate.month = event.month;
        this.selectedDate.day = event.day;
      } else {
        if (!this.selectedEndDate) {
          this.selectedEndDate = {
            year: null,
            month: null,
            day: null,
          };
        }
        this.selectedEndDate.year = event.year;
        this.selectedEndDate.month = event.month;
        this.selectedEndDate.day = event.day;
      }
      if (event.year.toString().length === 4 && (event.month.toString().length === 1 || event.month.toString().length === 2) && (event.day.toString().length === 1 || event.day.toString().length === 2)) {
        if (flag === false) {
          this.selectedEndDate = event;
        }
        if (flag === true) {
          this.dirtyFlag = false;
          this.isEnableClear = false;
        }
      } else {
        this.dirtyFlag = true;
      }
    } else {
      this.dirtyFlag = true;
    }
  }

  public onKeyPress(event: KeyboardEvent): boolean {
    if ((event.key >= '0' && event.key <= '9') || event.key === '/') {
      return true;
    }
    return false;
  }

  /*
  Set focus to the calendar date picker after giving it a short timeout to render.
  This is somewhat hacky, but there doesn't seem to be a better way to do it given how the markup is structured.
  This is implemented in response to QA's insistence that focus go back to the calendar automatically when the user exists the manual date picker.
  */
  public backToCalendarView(): void {
    this.enterDateManually = false;
    setTimeout((): void => {
      (document.getElementsByClassName('ngb-dp-arrow-btn')[0] as HTMLElement).focus();
    }, 100);
  }

  public onMonthChange(event: NgbDatepickerNavigateEvent): void {
    this.selectedMonths.emit(event);
  }

  private handleSelectedItem(item: Model.FilterOption<Model.CategoryOptions[]>): void {
    this.radioOptions = this.radioOptions.map((option) => {
      if (option.name === item.selectedOptions[0].name) {
        option.checked = true;
        if (option.name === 'ACH') {
          if (item.bankAccountIndex === undefined) {
            option.bankAccounts.forEach((account, index) => {
              if (index === 0) {
                account.checked = true;
              } else {
                account.checked = false;
              }
            });
          } else {
            option.bankAccounts.forEach((account, index) => {
              if (index === item.bankAccountIndex) {
                account.checked = true;
              } else {
                account.checked = false;
              }
            });
          }
        }
      } else {
        option.checked = false;
      }
      return option;
    });
  }

  private clearRadioSelection(): void {
    if (this.radioOptions) {
      this.radioOptions = this.radioOptions.map((option) => {
        option.checked = false;
        if (option.bankAccounts) {
          option.bankAccounts[0].checked = false;
        }
        return option;
      });
    }
  }

  private closePopup(): void {
    this.popupCancel.emit({ index: -1, active: this.getFilterActive(this.title) });
  }

  private camelize(value: string): string {
    return (
      value &&
      value
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (letter: string, index: number) => {
          return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
        })
        .replace(/\s+/g, '')
    );
  }

  private getFilterActive(name: string): boolean {
    let status: boolean;
    if (name.toLowerCase() === 'date range' || name === 'Date' || name === 'Hire Date') {
      status = !!sessionStorage.getItem('fromDate') || !!sessionStorage.getItem('toDate');
    } else {
      status = !!sessionStorage.getItem(this.camelize(name));
    }
    return status;
  }

  private getFormatDate(date: NgbDateStruct): string {
    let format: string = null;
    if (date) {
      format = date.month + '/' + date.day + '/' + date.year;
    }
    return format;
  }

  private getNgbDate(date: string): NgbDateStruct {
    const newDate: string[] = date.split('/');
    return { month: +newDate[0], day: +newDate[1], year: +newDate[2] };
  }

  private isValidDate(date: NgbDate): boolean {
    if (date.year.toString().length === 4 && (date.month.toString().length === 1 || date.month.toString().length === 2) && (date.day.toString().length === 1 || date.day.toString().length === 2)) {
      return true;
    } else {
      return false;
    }
  }

  private validateStartDate(): ValidationErrors {
    if (this.dateRangeForm) {
      const endDt = this.dateRangeForm.controls['selectedEndDate'].value;
      const startDt = this.dateRangeForm.controls['selectedDate'].value;
      let error = {};
      if (endDt !== '' && endDt !== null && startDt !== '' && startDt !== null) {
        const startDate: NgbDate = new NgbDate(startDt.year, startDt.month, startDt.day);
        const endDate: NgbDate = new NgbDate(endDt.year, endDt.month, endDt.day);
        if (endDate && endDate.year !== null && startDate && startDate.year !== null) {
          if (this.isValidDate(endDate) && this.isValidDate(startDate)) {
            this.isStartValid = false;
            if (
              (startDate.equals(endDate) || startDate.before(endDate)) &&
              startDate.after(this.minimumDate) &&
              (startDate.before(this.maximumDate) || startDate.equals(this.maximumDate)) &&
              endDate.after(this.minimumDate) &&
              (endDate.before(this.maximumDate) || endDate.equals(this.maximumDate))
            ) {
              this.dateRangeForm.controls['selectedDate'].setErrors(null);
              this.dateRangeForm.controls['selectedEndDate'].setErrors(null);
              this.isEndValid = true;
            }
            if (endDate.after(this.minimumDate) && endDate.before(this.maximumDate) && endDate.after(startDate)) {
              this.dateRangeForm.controls['selectedEndDate'].setErrors(null);
            }
            if (startDate.before(this.minimumDate) && this.isOptionsEmpty) {
              error = { dateError: true };
              const message = this.itemName === 'Date' ? '18 months' : '3 years';
              this.errorMessage = ` Report start date or end date cannot be more than ${message} before today's date`;
            }
            if (startDate.after(endDate) && endDate.after(this.minimumDate) && endDate.before(this.maximumDate)) {
              error = { dateError: true };
              this.errorMessage = ' Report start date cannot be after report end date';
            }
            if (startDate.after(this.maximumDate)) {
              error = { dateError: true };
              this.errorMessage = ' Report start or end date cannot be in the future';
            }
            if (startDate.after(this.minimumDate) && startDate.before(this.maximumDate) && endDate.after(this.maximumDate)) {
              error = { dateError: true };
              this.dateRangeForm.controls['selectedDate'].setErrors(null);
              if (document.querySelector('#startDate').classList.contains('mat-form-field-invalid')) {
                document.querySelector('#startDate').classList.remove('mat-form-field-invalid');
              }
              this.errorMessage = ' Report start or end date cannot be in the future';
            }
            if (Object.keys(error).length === 0) {
              this.dateRangeForm.controls['selectedDate'].setErrors(null);
              this.isStartValid = true;
              this.removeErrorMessages();
            } else {
              this.dirtyFlag = true;
            }
            return error;
          }
        }
      } else if (startDt !== '' && startDt !== null) {
        const startDate: NgbDate = new NgbDate(startDt.year, startDt.month, startDt.day);
        if (startDate.before(this.minimumDate) && this.isOptionsEmpty) {
          error = { dateError: true };
          const message = this.itemName === 'Date' ? '18 months' : '3 years';
          this.errorMessage = `Report start date or end date cannot be more than ${message} before today's date`;
        }
        if (startDate.after(this.maximumDate)) {
          error = { dateError: true };
          this.errorMessage = 'Report start or end date cannot be in the future';
        }
        return error;
      }
    }
  }

  private validateEndDate(): ValidationErrors {
    if (this.dateRangeForm) {
      const endDt = this.dateRangeForm.controls['selectedEndDate'].value;
      const startDt = this.dateRangeForm.controls['selectedDate'].value;
      let error = {};
      if (endDt !== '' && endDt !== null && startDt !== '' && startDt !== null) {
        const startDate: NgbDate = new NgbDate(startDt.year, startDt.month, startDt.day);
        const endDate: NgbDate = new NgbDate(endDt.year, endDt.month, endDt.day);
        if (endDate && endDate.year !== null && startDate && startDate.year !== null) {
          if (this.isValidDate(endDate) && this.isValidDate(startDate)) {
            this.isEndValid = false;
            if (endDate.before(this.minimumDate) && this.isOptionsEmpty) {
              error = { dateError: true };
              this.errorMessage = 'Report start date or end date cannot be more than 3 years before today\'s date';
            }
            if (endDate.after(startDate) && startDate.after(this.minimumDate) && startDate.before(this.maximumDate)) {
              this.dateRangeForm.controls['selectedDate'].setErrors(null);
            }
            if (endDate.before(startDate)) {
              error = { dateError: true };
              this.errorMessage = 'Report start date cannot be after report end date';
            }
            if (endDate.after(this.maximumDate)) {
              error = { dateError: true };
              this.errorMessage = 'Report start or end date cannot be in the future';
            }
            if (Object.keys(error).length === 0) {
              this.dateRangeForm.controls['selectedEndDate'].setErrors(null);
              this.isEndValid = true;
              this.removeErrorMessages();
            } else {
              this.dirtyFlag = true;
            }
            return error;
          }
        }
      } else if (endDt !== '' && endDt !== null) {
        const endDate: NgbDate = new NgbDate(endDt.year, endDt.month, endDt.day);
        if (endDate.before(this.minimumDate) && this.isOptionsEmpty) {
          error = { dateError: true };
          this.errorMessage = 'Report start date or end date cannot be more than 3 years before today\'s date';
        }
        if (endDate.after(this.maximumDate)) {
          error = { dateError: true };
          this.errorMessage = 'Report start or end date cannot be in the future';
        }
        return error;
      }
    }
  }

  private removeErrorMessages(): void {
    if (this.enterDateManually && this.isEndValid === undefined) {
      this.validateEndDate();
    }
    if (this.enterDateManually && this.isStartValid === undefined) {
      this.validateStartDate();
    }
    if (this.isStartValid && this.isEndValid && this.isEnableClear) {
      this.errorMessage = '';
      this.dirtyFlag = false;
    }
  }

  private updateDisabledDates(): void {
    this.markDisabled = (date: NgbDate): boolean => {
      const dateValue = dayjs(date.year + '-' + date.month + '-' + date.day)
        .format('YYYY-MM-DD')
        .toString();
      if (this.datesToEnable.length > 0) {
        return this.datesToEnable.indexOf(dateValue) >= 0 ? false : true;
      } else {
        return true;
      }
    };
  }
}
